import { DatePipe, formatDate } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { LoadingService, Page, TableColumn } from '@serpro/ngx-suite-rfb';
import { isEmpty, isEqual } from 'lodash';
import { Subscription } from 'rxjs';
import { filter, map, mergeMap, take } from 'rxjs/operators';
import { CCPFService } from 'src/app/cobranca/components/ccpf/services/ccpf.service';
import { DocumentoArrecadacaoRetificacao_DTO } from 'src/app/mockup/entities/documento-arrecadacao-retificacao-base1TO-dto.mock';
import { DynamicModalRequestService } from 'src/app/shared/dynamic-modal/dynamic-modal-request.service';
import { IDynamicPanel, OptionalParams } from 'src/app/shared/dynamic-panel/panel-interface';
import { MenuFeatureActionsService } from 'src/app/shared/menu-feature-actions/menu-feature-actions.service';
import { FeatureAction, TipoMenu } from 'src/app/shared/model/feature';
import { FormatCurrencyPipe } from 'src/app/shared/pipes/formata-valor.pipe';
import { VazioPipe } from 'src/app/shared/pipes/vazio/vazio.pipe';
import { ScopedMessageService } from 'src/app/shared/services/scoped-message.service';
import { COLUNA_ACAO, COLUNA_PADRAO, ColunaCustomizada, ViaSuiteRfbTableComponent } from 'src/app/shared/table/via-suite-rfb-table.component';
import { encadearPipes } from 'src/app/shared/util/pipe-utils';
import { FormatCnpjPipe } from '../../../shared/pipes/formata-cnpj.pipe';
import { FormatCpfPipe } from '../../../shared/pipes/formata-cpf.pipe';
import { DocumentoArrecadacaoRetificacaoBase1TO } from '../../models/documento-arrecadacao-retificacao-base1-to';
import { Pagamento } from '../../models/pagamento';
import { ParametrosPesquisaPagamento } from '../../models/parametros-pesquisa';
import { TipoDocumentoEnum } from '../../models/tipo-documento-dto';
import { TipoNIRDOC } from '../../models/tipo-ni-rdoc';
import { TipoRetificacao } from '../../models/tipo-retificacao';
import { PagamentoComprovanteService } from '../../services/pagamento-comprovante.service';
import { PagamentoService } from '../../services/pagamento.service';
import { RetificacaoPagamentoComponent } from '../retificacao/retificacao-pagamento.component';
import { TrocaAssinalamentoPagamentoComponent } from '../troca-assinalamento/troca-assinalamento-pagamento.component';
import { DOCUMENTO_ARRECADACAO_CNPJ_COMPLETA_MOCK } from 'src/app/mockup/entities/pagamentos/documento-arrecadacao-cnpj-completa-dto.mock';
import { DOCUMENTO_ARRECADACAO_CPF_COMPLETA_MOCK } from 'src/app/mockup/entities/pagamentos/documento-arrecadacao-cpf-completa-dto.mock';
import { DOCUMENTO_ARRECADACAO_CNPJ_SIMPLIFICADA_MOCK } from 'src/app/mockup/entities/pagamentos/documento-arrecadacao-cnpj-simplificada-dto.mock';
import { DOCUMENTO_ARRECADACAO_CPF_SIMPLIFICADA_MOCK } from 'src/app/mockup/entities/pagamentos/documento-arrecadacao-cpf-simplificada-dto.mock';
import { RetornoVerificaRetificacaoTO } from '../../models/retorno-verifica-retificacao-to';
import { RETORNO_VERIFICA_RETIFICACAO_CNPJ_COMPLETA_MOCK } from 'src/app/mockup/entities/pagamentos/retorno-verifica-retificacao-cnpj-completa-dto.mock';
import { RETORNO_VERIFICA_RETIFICACAO_CPF_COMPLETA_MOCK } from 'src/app/mockup/entities/pagamentos/retorno-verifica-retificacao-cpf-completa-dto.mock';
import { RETORNO_VERIFICA_RETIFICACAO_CNPJ_SIMPLIFICADA_MOCK } from 'src/app/mockup/entities/pagamentos/retorno-verifica-retificacao-cnpj-simplificada-dto.mock';
import { RETORNO_VERIFICA_RETIFICACAO_CPF_SIMPLIFICADA_MOCK } from 'src/app/mockup/entities/pagamentos/retorno-verifica-retificacao-cpf-simplificada-dto.mock';

@Component({
  selector: 'via-consulta-pagamentos',
  templateUrl: './consulta-pagamentos.component.html',
  styleUrls: ['./consulta-pagamentos.component.css'],
  providers: [ScopedMessageService]
})
export class ConsultaPagamentosComponent implements IDynamicPanel, OnChanges, OnInit, OnDestroy {

  @Input() parametrosPesquisa: ParametrosPesquisaPagamento;
  @Input() atendimento: boolean = true;

  @ViewChild('tabelaPagamentos', { static: true }) tabelaPagamentos: ViaSuiteRfbTableComponent;
  @ViewChild('templateBotaoAcoes', { static: true }) templateBotaoAcoes: TemplateRef<Component>;
  @ViewChild('templateNi', { static: true }) templateNi: TemplateRef<Component>;
  @ViewChild('templateReceita', { static: true }) templateReceita: TemplateRef<Component>;
  @ViewChild('templateBancoAgencia', { static: true }) templateBancoAgencia: TemplateRef<Component>;

  public columns: TableColumn[] = [];
  public initError: Error;
  public isLoading: boolean = false;

  scopeId: string;
  resultadosPesquisa: Pagamento[];
  titulo: string;
  updateSubscription: Subscription;
  pageSize: number = 10;
  currentPage: Page = {
    number: 1,
    first: 0,
    last: this.pageSize
  };

  // '01' - SISTEMA DE INTERESSE 'CONTA COR-PF'
  alocacaoAutomaticaTipoSistemaPermitido = '01';

  public TipoDocumentoEnum: typeof TipoDocumentoEnum = TipoDocumentoEnum;
  public TipoNIRDOC: typeof TipoNIRDOC = TipoNIRDOC;

  public sortBy = {
    asc: null,
    field: null,
  }

  constructor(
    private loadingService: LoadingService,
    private pagamentoService: PagamentoService,
    private messageService: ScopedMessageService,
    private menuFeatureActionsService: MenuFeatureActionsService,
    private dynamicModalRequest: DynamicModalRequestService,
    private ccpfService: CCPFService,
    private pagamentoComprovanteService: PagamentoComprovanteService,
  ) { }

  public ngOnInit(): void {
    this.scopeId = this.messageService.scopeId;
    if (!this.titulo) {
      this.titulo = this.atendimento ? 'Resultado da Pesquisa' : 'Pagamento - Resultado da Pesquisa';
    }
    this.recarregar();
    this.updateSubscription = this.pagamentoService.atualizarListagemEmitter.subscribe(
      parametros => {
        if (isEqual(parametros, this.parametrosPesquisa)) {
          this.recarregar();
        }
      }
    );

    const datePipe = new DatePipe("pt-BR", null, { dateFormat: "dd/MM/yyyy" });
    const vazioPipe = new VazioPipe();
    const formatCurrencyPipe = new FormatCurrencyPipe();

    this.columns = [
      { ...COLUNA_PADRAO, ...COLUNA_ACAO, name: "Ações", cellTemplate: this.templateBotaoAcoes, maxWidth: 60 },
      { ...COLUNA_PADRAO, name: "CPF/CNPJ", prop: "ni", cellTemplate: this.templateNi, maxWidth: 166, comparator: this.compararPorNi },
      { name: ColunaCustomizada.EXPANDIR },
      { ...COLUNA_PADRAO, name: "Receita", prop: "receita01.codigo", cellTemplate: this.templateReceita, maxWidth: 82 },
      { ...COLUNA_PADRAO, name: "Data Arrec.", prop: "pgtoDtArrecadacao", pipe: encadearPipes([datePipe, vazioPipe]), maxWidth: 112 },
      { ...COLUNA_PADRAO, name: "Bco/Ag.", prop: "pgtoAgenAgtaCd", cellTemplate: this.templateBancoAgencia, maxWidth: 80, comparator: this.compararPorBancoAgencia },
      { ...COLUNA_PADRAO, name: "Data Venc.", prop: "pgtoDtVencimento", pipe: encadearPipes([datePipe, vazioPipe]), maxWidth: 112 },
      { ...COLUNA_PADRAO, name: "PA", prop: "pgtoDtEncerraPerApu", pipe: encadearPipes([datePipe, vazioPipe]), maxWidth: 112 },
      { ...COLUNA_PADRAO, name: "Valor Total", prop: "pgtoVlTotal", pipe: encadearPipes([formatCurrencyPipe, vazioPipe]), maxWidth: 110, cellClass: "flex direita" },
      { ...COLUNA_PADRAO, name: "Situação", prop: "situacao.descricao", pipe: vazioPipe, maxWidth: 106, cellClass: "flex centralizar text-center", },
      { ...COLUNA_PADRAO, name: "Sist. Interesse", prop: "sistemaInteresse.descricao", pipe: vazioPipe, cellClass: "flex esquerda" },
    ];

    // Remove a coluna de CPF/CNPJ se for um atendimento para evitar quebra de layout da tabela
    // A coluna não é necessária no contexto de atendimento, pois a ação pode ser realizada diretamente no menu à esquerda
    if (this.atendimento) {
      this.columns = this.columns.filter((c) => c.name !== "CPF/CNPJ");
    }
  }

  public get tituloTabela(): string {
    let titulo = "Resultados da Pesquisa";

    if (this.parametrosPesquisa.periodoArrecadacao?.dataInicial && this.parametrosPesquisa.periodoArrecadacao?.dataFinal) {
      const pipe = new VazioPipe();

      const dataInicial = pipe.transform(formatDate(this.parametrosPesquisa.periodoArrecadacao.dataInicial, 'dd/MM/yyyy', 'pt-BR'));
      const dataFinal = pipe.transform(formatDate(this.parametrosPesquisa.periodoArrecadacao.dataFinal, 'dd/MM/yyyy', 'pt-BR'));

      titulo += ` a partir de ${dataInicial} a ${dataFinal}`;
    }

    return titulo;
  }

  public init(_ni: string, params?: OptionalParams): void {
    this.scopeId = this.messageService.scopeId;
    this.atendimento = params?.atendimento;
    this.parametrosPesquisa = params?.parametrosPesquisa as ParametrosPesquisaPagamento;
    const cpfContribuinte = params?.cpf;
    const cnpjContribuinte = params?.cnpj;

    if (cpfContribuinte || cnpjContribuinte)
      this.formataTitulo(cpfContribuinte, cnpjContribuinte);

  }

  private compararPorNi(a: string, b: string, ra: Pagamento, rb: Pagamento): number {
    const PESOS = {
      [TipoNIRDOC.CPF]: 1,
      [TipoNIRDOC.CNPJ]: 2,
      [TipoNIRDOC.NI_INVALIDO]: 3,
    }

    if (ra.tipoNiRdoc !== rb.tipoNiRdoc) {
      return PESOS[ra.tipoNiRdoc] - PESOS[rb.tipoNiRdoc];
    }

    if (a.length !== b.length) {
      return a.length - b.length;
    }

    return a.localeCompare(b);
  }

  private compararPorBancoAgencia(a: string, b: string, ra: Pagamento, rb: Pagamento): number {
    if (ra.pgtoAgenAgtaCd !== rb.pgtoAgenAgtaCd) {
      return ra.pgtoAgenAgtaCd > rb.pgtoAgenAgtaCd ? 1 : -1;
    }

    return ra.pgtoAgenCd > rb.pgtoAgenCd ? 1 : -1;
  }

  private formataTitulo(cpfContribuinte: string, cnpjContribuinte: string): void {
    if (cpfContribuinte) {
      this.titulo = ` Pagamento - CPF: ${FormatCpfPipe.formatCPF(cpfContribuinte)}`;
    }
    if (cnpjContribuinte) {
      this.titulo = ` Pagamento - CNPJ: ${FormatCnpjPipe.formatCNPJ(cnpjContribuinte)}`;
    }
  }

  public ngOnChanges(): void {
    if (this.titulo) {
      this.recarregar();
    }
  }

  public ngOnDestroy(): void {
    this.updateSubscription?.unsubscribe();
  }

  public recarregar(): void {
    this.isLoading = true;
    this.initError = null;
    this.resultadosPesquisa = null;
    this.pesquisarPagamentos();
  }

  private pesquisarPagamentos(): void {
    // TODO: paginação (obs: rdoc não tem ordenação)
    const firstIndex = 0;
    const maxResults = 10;
    this.pagamentoService.consultarPagamentos(this.parametrosPesquisa, firstIndex, maxResults)
      .pipe(
        take(1),
        map((ps) => ps?.map((p) => new Pagamento(p)))
      )
      .subscribe({
        next: (response) => {
          if (isEmpty(response)) {
            this.messageService.showInfo('Nenhum registro encontrado', "", [], { dismissible: false });
            this.isLoading = false;
            return;
          }

          // 760981 RN - Pagamento - Dados de Pagamentos
          // RN1.1-09/16 - Ordenação de Dados de Pagamentos
          // Os pagamentos da tabela resultante da consulta serão inicialmente apresentados em ordem decrescente de Data Arrec. (10)
          if (response && response.length > 0) {
            response.sort((a, b) => {
              return b.pgtoDtArrecadacao?.getTime() - a.pgtoDtArrecadacao?.getTime();
            });
          }

          this.isLoading = false;
          this.resultadosPesquisa = response;
          this.currentPage.last = this.resultadosPesquisa.length > this.pageSize ? this.pageSize : this.resultadosPesquisa.length;
        },
        error: () => {
          this.initError = new Error("Error ao consultar pagamentos");
          this.messageService.showError('Ocorreu um erro ao executar a pesquisa', "", [], { dismissible: false });
        }
      });
  }

  public emitirComprovante(pagamento: Pagamento): void {
    this.loadingService.show();

    this.pagamentoComprovanteService.obterComprovantePagamento(pagamento.pgtoNr).subscribe(
      response => {
        this.loadingService.hide();
        this.pagamentoComprovanteService.visualizarComprovante(response, 'Comprovante de Pagamento');
      },
      error => {
        this.loadingService.hide();
        this.messageService.showErrorException('Ocorreu um erro na emissão do comprovante de pagamento', error);
      }
    );
  }

  public iniciarRetificacaoSimplificada(pagamento: Pagamento): void {
    this.iniciarRetificacao(pagamento, DocumentoArrecadacaoRetificacao_DTO, TipoRetificacao.SIMPLIFICADA);
    // this.iniciarRetificacao(documentoArrecadacao, TipoRetificacao.SIMPLIFICADA);
  }

  public iniciarRetificacaoCompleta(pagamento: Pagamento): void {
    this.iniciarRetificacao(pagamento, DocumentoArrecadacaoRetificacao_DTO, TipoRetificacao.COMPLETA);
    //this.iniciarRetificacao(pagamento, TipoRetificacao.COMPLETA);
  }

  private iniciarRetificacao(pagamento: Pagamento, docArrecRetificaBase1: DocumentoArrecadacaoRetificacaoBase1TO, tipoRetificacao: TipoRetificacao): void {
    this.loadingService.show();

    let documentoArrecadacaoRetificacao: DocumentoArrecadacaoRetificacaoBase1TO;
    let retornoVerificacao: RetornoVerificaRetificacaoTO;

    if(tipoRetificacao === TipoRetificacao.COMPLETA && pagamento.tipoNiRdoc === TipoNIRDOC.CNPJ) {
      documentoArrecadacaoRetificacao = DOCUMENTO_ARRECADACAO_CNPJ_COMPLETA_MOCK;
      retornoVerificacao = RETORNO_VERIFICA_RETIFICACAO_CNPJ_COMPLETA_MOCK
    }
    else if(tipoRetificacao === TipoRetificacao.COMPLETA && pagamento.tipoNiRdoc === TipoNIRDOC.CPF) {
      documentoArrecadacaoRetificacao = DOCUMENTO_ARRECADACAO_CPF_COMPLETA_MOCK;
      retornoVerificacao = RETORNO_VERIFICA_RETIFICACAO_CPF_COMPLETA_MOCK
    }
    else if(tipoRetificacao === TipoRetificacao.SIMPLIFICADA && pagamento.tipoNiRdoc === TipoNIRDOC.CNPJ) {
      documentoArrecadacaoRetificacao = DOCUMENTO_ARRECADACAO_CNPJ_SIMPLIFICADA_MOCK;
      retornoVerificacao = RETORNO_VERIFICA_RETIFICACAO_CNPJ_SIMPLIFICADA_MOCK
    }
    else if(tipoRetificacao === TipoRetificacao.SIMPLIFICADA && pagamento.tipoNiRdoc === TipoNIRDOC.CPF) {
      documentoArrecadacaoRetificacao = DOCUMENTO_ARRECADACAO_CPF_SIMPLIFICADA_MOCK;
      retornoVerificacao = RETORNO_VERIFICA_RETIFICACAO_CPF_SIMPLIFICADA_MOCK
    }

    this.pagamentoService[tipoRetificacao === TipoRetificacao.COMPLETA ? 'verificaRetificacao' : 'verificaRetificacaoSimplificada'](documentoArrecadacaoRetificacao).subscribe(
      rv => {
        this.loadingService.hide();

        if (this.atendimento) {
          const item: FeatureAction = {
            id: `pagamento_${pagamento.pgtoNr}`,
            title: `Pagamento - Retificação ${tipoRetificacao}`,
            class: RetificacaoPagamentoComponent,
            visible: true,
            rolesAllowed: [],
            tipoMenu: TipoMenu.ATENDIMENTO,
            parametros: {
              parametrosPesquisa: this.parametrosPesquisa,
              atendimento: this.atendimento,
              pagamento: pagamento,
              camposAlteraveis: retornoVerificacao.camposAlteraveis,
              tipoRetificacao: tipoRetificacao,
              docArrecRetificaBase1: documentoArrecadacaoRetificacao
            }
          };

          this.menuFeatureActionsService.activate(item);
        }
        else {
          const feature = new FeatureAction();
          feature.class = RetificacaoPagamentoComponent;
          feature.parametros = {
            parametrosPesquisa: this.parametrosPesquisa,
            pagamento: pagamento,
            camposAlteraveis: retornoVerificacao.camposAlteraveis,
            tipoRetificacao: tipoRetificacao,
            docArrecRetificaBase1: documentoArrecadacaoRetificacao
          }

          this.dynamicModalRequest.abrirModal(feature);
        }
      },
      error => {
        this.loadingService.hide();
        if (error.error.message.includes('retificação simplificada')) {
          this.messageService.showErrorException('', error);
        } else {
          this.messageService.showErrorException('Ocorreu um erro ao verificar permissões', error);
        }
      });
       
      }   ;
  
  

  public trocarAssinalamento(resultado: Pagamento): void {
    const trocaAssinalamentoFeature = {
      id: `PagamentoTrocaAssinalamento_pagamento_${resultado.pgtoNr}`,
      title: `Pagamento - Trocar Assinalamento - ${resultado.pgtoNr}`,
      class: TrocaAssinalamentoPagamentoComponent,
      parametros: {
        parametrosPesquisa: this.parametrosPesquisa,
        atendimento: this.atendimento
      }
    } as FeatureAction;

    const consultaTrocaAssinalamento = this.pagamentoService.obterRegistroTroca([resultado.pgtoNr]).pipe(
      filter(documentoArrecadacao => documentoArrecadacao !== null),
      mergeMap((documentoArrecadacao) => {
        trocaAssinalamentoFeature.parametros.documentoArrecadacao = documentoArrecadacao;
        return this.pagamentoService.verificarTrocaAssinalamento(documentoArrecadacao);
      })
    );

    consultaTrocaAssinalamento.subscribe({
      next: (podeTrocarAssinalamento: boolean) => {
        if (!podeTrocarAssinalamento) {
          // backend lança exceção antes
        }
        if (this.atendimento) {
          trocaAssinalamentoFeature.active = true;
          trocaAssinalamentoFeature.rolesAllowed = [];
          trocaAssinalamentoFeature.tipoMenu = TipoMenu.ATENDIMENTO;
          this.menuFeatureActionsService.activate(trocaAssinalamentoFeature);
          return;
        }

        this.dynamicModalRequest.abrirModal(trocaAssinalamentoFeature);
      }
    });
  }

  public impedirAlocacaoAutomatica(pagamento: Pagamento): void {
    this.loadingService.show();

    this.ccpfService.impedirAlocacaoAutomatica(pagamento.ni, pagamento.pgtoNr).subscribe(
      () => {
        this.loadingService.hide();
        this.pagamentoService.atualizarListagemPagamento(this.parametrosPesquisa);
        this.messageService.showInfo('Operação Impedir Alocação Automática realizada com sucesso', `Pagamento ${pagamento.pgtoNr}`);
      },
      error => {
        this.loadingService.hide();
        this.messageService.showErrorException('Ocorreu um erro ao tentar executar a operação Impedir Alocação Automática', error);
      }
    );
  }

  public liberarAlocacaoAutomatica(pagamento: Pagamento): void {
    this.loadingService.show();

    this.ccpfService.liberarAlocacaoAutomatica(pagamento.ni, pagamento.pgtoNr).subscribe(
      () => {
        this.loadingService.hide();
        this.pagamentoService.atualizarListagemPagamento(this.parametrosPesquisa);
        this.messageService.showInfo('Operação Liberar Alocação Automática realizada com sucesso', `Pagamento ${pagamento.pgtoNr}`);
      },
      error => {
        this.loadingService.hide();
        this.messageService.showErrorException('Ocorreu um erro ao tentar executar a operação Liberar Alocação Automática', error);
      }
    );
  }

  public detalharPagamento(pagamento: Pagamento): void {
    if (!this.tabelaPagamentos?.isRowExpanded(pagamento)) {
      this.tabelaPagamentos?.toggleExpandRow(pagamento, true);
    }
  }
}
